import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import axios from 'axios';
import store from './store';

import CPage from "./components/c-page/CPage.vue"
import CHome from "./components/CHome.vue"
import COperatorLogin from "./components/COperatorLogin.vue"
import { pages } from '@/pages';
import { RolesService } from './services/RolesService';
import { Page } from "./models/page-models/Page";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  { path: '/', name: 'Home', component: CHome, meta: { requiresAuth: false } },
  ...pages.map((page : Page) => ({
    path: `/${page.path}`,
    name: page.name,
    component: CPage,
    props: page.props,
    meta: { requiresAuth: true }
  })),
  { path: '/operator', name: 'operator', component: COperatorLogin, meta: { requiresAuth: true } }
];

const router = new VueRouter({
  mode: "history",
  routes: routes
});

router.beforeEach(async (to, from, next) => {
  if (!store.state.user.loggedIn) {
    await store.dispatch('refreshUser');
    // console.log(35, 'loggedINn: ', store.state.user.loggedIn);
    if (store.state.app.rolesArray.length == 0) {
      // console.log(37, 'B: RolesService.init()');
      await RolesService.init();
    }
  }
  if(to.meta?.requiresAuth == false && !store.state.user.loggedIn) {
    // console.log('A', to.name);
    next();
  } else {
    // console.log(45, 'B: requiresAuth',to.meta.requiresAuth);
    if (!store.state.user.loggedIn) {
      await store.dispatch('refreshUser');
      // console.log(48, 'B: refreshUser');
    }
    if (!store.state.user.loggedIn) {
      // console.log(51, 'B: login fail redirect home');
      store.commit('setSnackbar', { serverMessage: 'Please login!', show: true, color: 'error' });
      next('/');
    }
    if(to.query && to.query.role && to.query.role != store.state.user.role) {
      // console.log(56, 'B: change role if wrong role');
      try {
        await axios.post('/api/v1/users/initializeRole', {
          id: store.state.user._id,
          role: to.query.role,
          changeActiveRole:true
        });
      } catch (error) {
        store.commit('setSnackbar', { serverMessage: `Role change failed!`, show: true, color: 'error' });
      }
      await store.dispatch('refreshUser');
    }
    if (store.state.user.isAdmin && to.query.role == null) {
      // console.log(69, 'B: add role param for admin');
      to.query.role = store.state.user.role[0];
      const { path, query, params } = to;
      next({ path, query, params });
    }
    if(store.state.user.role.includes('Production | Operator') && !(store.state.user.operatorId > -1)) {
      await store.dispatch('refreshUser');
      if(!(store.state.user.operatorId > -1) && to.name !== 'operator') {
        // console.log(77, 'Redirect to Operator login');
        next('/operator');
      } else {
        next();
      }
    } else {
      const filteredPages = pages.filter((page: Page) => page.name === to.name);
      if(filteredPages.length > 0) {
        const page = filteredPages.find((page: Page) => page.forRole === '*' || store.getters.roleMatches(page.forRole));
        if(page) {
          // console.log(87, 'B: route matched to page SUCCESS');
          next();
        } else {
          const serverMessage = store.state.user.loggedIn ? 'Page is for a different role' : 'Please login!';
          store.commit('setSnackbar', { serverMessage, show: true, color: 'error' })
          // console.log(92, 'B: wrong role');
          loadTopmostPage(next, to.name);
        }
      } else {
        // console.log(96, 'B: page not found');
        loadTopmostPage(next, to.name);
      }
    }
  }
})

function loadTopmostPage(next: Function, suggestedRouteName?: string | null) {
  const targetPage = pages.find((page: Page) => store.getters.roleMatches(page.forRole) && page.visible);
  if (targetPage) {
    // console.log(106, 'B: loading highest priority page for role');
    next(`/${targetPage.path}`)
  } else {
    // console.log(109, 'B: worst case -- redirect to home page to clear UI');
    if(!suggestedRouteName) next(`/`);
  }
}

export default router